/**
 * How a statement is structured: positions into groups, groups into the statement, subtotals in
 * between. Mirrors the static catalogue `aumico-be` sends with the account list.
 *
 * Plain data, so the structure can change without touching the code that evaluates or renders it.
 * Label keys are i18n keys; the backend never sends text.
 */
export type StatementNode =
    | {
          kind: 'GROUP';
          /** Unique within the layout and stable: collapse state and tests key on it. */
          id: string;
          /** The heading row. Absent = no heading. */
          labelKey?: string;
          /** The closing «Total …» row. Absent = no total row. */
          totalLabelKey?: string;
          children: StatementNode[];
      }
    | {
          kind: 'POSITION';
          id: string;
          /** The `accountGroup` whose accounts hang here. */
          position: string;
      }
    | {
          kind: 'SUBTOTAL';
          id: string;
          labelKey: string;
      };

export interface IStatementLayout {
    statement: 'BALANCE_SHEET' | 'INCOME_STATEMENT';
    roots: StatementNode[];
    /** The node whose value is 100 % («% vom Betriebsertrag»). */
    percentBaseNodeId?: string;
}

export interface IStatementLayouts {
    version: string;
    balanceSheet: IStatementLayout;
    incomeStatement: IStatementLayout;
}
